module.exports = __webpack_public_path__ + "static/media/clearly2.f58ed3e3.mp3";